<canvas [hidden]="isDataEmpty" id="donutChart-{{ chartId }}"></canvas>
<img *ngIf="isDataEmpty" class="h-100 w-100" src="/assets/img/empty-donut.svg" />
